/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PearsonTemplateParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('pearson-template')],
    ['id', codecString],
    ['editable', codecBoolean],
]);
export class PearsonTemplate extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PearsonTemplateParser.decode(input).map(res => new PearsonTemplate(res));
    }
    static unsafeDecode(input) {
        return PearsonTemplate.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PearsonTemplateParser.encode(data);
    }
    static schema() {
        return PearsonTemplateParser.schema();
    }
}
